module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-43.42a28b92.png";